/** @format */

import {
  loadCommodity,
  showDeleteConfirmationDialog,
  setSelectedCommodity,
  showAddEditDialog,
  editCommodityDetails,
  addCommodityDetails,
  setDeletedCommodity,
} from "./commodityActions";

export const getNewCommodityDetail = () => ({
  commodityDetailId: "",
  commoditySymbol: "",
  createdBy: "",
  createdDate: "",
});
export const newCommodity = {
  name: "",
  commodityDetails: [],
  commodityType: "C3",
  reference: "",
  exchange: "",
};
export const initialCommodityState = {
  commodities: [],
  deletedCommodities: [],
  showDeleteConfirmDialog: false,
  showInsertEditDialog: false,
  selectedCommodity: {},
  isEditingCommodity: false,
  isAddingCommodity: false,
};

export const commoditiesReducer = (state = initialCommodityState, action) => {
  switch (action.type) {
    case loadCommodity.type:
      return {
        ...state,
        commodities: action.payload,
      };
    case showDeleteConfirmationDialog.type:
      return {
        ...state,
        showDeleteConfirmDialog: action.payload,
      };
    case showAddEditDialog.type:
      return {
        ...state,
        showInsertEditDialog: action.payload,
      };
    case setSelectedCommodity.type:
      return {
        ...state,
        selectedCommodity: action.payload,
      };
    case setDeletedCommodity.type:
      return {
        ...state,
        deletedCommodities: action.payload,
      };
    case editCommodityDetails.type:
      return {
        ...state,
        isEditingCommodity: action.payload,
      };
    case addCommodityDetails.type:
      return {
        ...state,
        isAddingCommodity: action.payload,
      };
    default:
      return state;
  }
};
